import {
  propSatisfies,
  not,
  both,
  always,
  cond,
  prop,
  pipe,
  keys,
  countBy,
  lt,
  split,
  head,
  startsWith,
  complement,
  endsWith,
  propEq,
  anyPass,
  equals
} from 'ramda'

const isImage = propSatisfies(
  both(startsWith('image'), complement(endsWith('gif'))),
  'type'
)
const isGif = propEq('type', 'image/gif')
const isVideo = propSatisfies(startsWith('video'), 'type')

const maxImageSize = 5e6 // 5 MB
const maxGifSize = 15e6 // 15 MB
const maxVideoSize = 1e9 // 1 GB
const maxVideoDuration = 140 // seconds
const maxOverlayGifSize = 1e6 // 1 MB

const overSize = max => propSatisfies(lt(max), 'size')

const overImageSize = overSize(maxImageSize)
const imageTooLarge = both(isImage, overImageSize)

const overGifSize = overSize(maxGifSize)
const gifTooLarge = both(isGif, overGifSize)

const overVideoSize = overSize(maxVideoSize)
const videoTooLarge = both(isVideo, overVideoSize)

const overDuration = propSatisfies(lt(maxVideoDuration), 'duration')
const videoTooLong = both(isVideo, overDuration)

export const validateFile = cond([
  [
    anyPass([imageTooLarge, gifTooLarge, videoTooLarge]),
    always('File too large to upload.')
  ],
  [videoTooLong, always('Video longer than 2m 40s.')]
])

const gt1 = lt(1)
const gt4 = lt(4)
const lengthGt1 = pipe(
  prop('length'),
  gt1
)
const lengthGt4 = pipe(
  prop('length'),
  gt4
)

const isDm = prop('isDm')
const isTweet = propSatisfies(not, 'isDm')

const moreThan1File = propSatisfies(lengthGt1, 'files')
const dmInvalid = both(isDm, moreThan1File)

const moreThan4Files = propSatisfies(lengthGt4, 'files')
const tweetInvalid = both(isTweet, moreThan4Files)

const type = pipe(
  prop('type'),
  cond([
    [startsWith('video'), always('video')],
    [equals('image/gif'), always('gif')],
    [startsWith('image'), always('image')]
  ])
)

const moreThan1Type = pipe(
  countBy(type),
  keys,
  lengthGt1
)

const typesInvalid = propSatisfies(moreThan1Type, 'files')

const moreThan1Gif = pipe(
  countBy(type),
  prop('gif'),
  gt1
)
const gifCountInvalid = propSatisfies(moreThan1Gif, 'files')

const videoType = pipe(
  prop('type'),
  split('/'),
  head
)
const moreThan1Video = pipe(
  countBy(videoType),
  prop('video'),
  gt1
)
const videoCountInvalid = propSatisfies(moreThan1Video, 'files')

const overGifOverlayMaxSize = overSize(maxOverlayGifSize)
const overlayGifTooLarge = both(isGif, overGifOverlayMaxSize)
const overlayGifInvalid = both(prop('actionType'), overlayGifTooLarge)

const validate = cond([
  [dmInvalid, always("You can't upload more than 1 file")],
  [tweetInvalid, always("You can't upload more than 4 images")],
  [gifCountInvalid, always("You can't upload more than 1 GIF")],
  [videoCountInvalid, always("You can't upload more than 1 video")],
  [typesInvalid, always("You can't upload more than 1 file type")],
  [
    overlayGifInvalid,
    always("You can't upload a GIF larger than 1 MB for overlays")
  ]
])

export default validate



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/validation.js